export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';
export const GOOGLE_MAPS_API_KEY =
  process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '';
export const FACEBOOK_APP_ID = process.env.REACT_APP_API_BASE_URL || '';
export const REACT_APP_BASE_PATH_S3 = process.env.REACT_APP_BASE_PATH_S3 || '';
export const API_DEEP_DIVE_URL = process.env.REACT_APP_API_DEEP_DIVE_URL || '';
